import { OpportunityStatusEnum } from "@repo/api";
import { t } from "@repo/translation";
import { FilterCheckbox, translateProjectStatus, useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const StatusFilter = ({ actions, filters }: FilterItemsProps) => {
  const { customer_communication } = useSettings();
  const isColdProjectEnabled =
    customer_communication?.cold_projects?.enable || false;

  return (
    <FilterListContainer id="status-filter">
      <FilterCheckbox
        id="UNASSIGNED"
        value="UNASSIGNED"
        label={translateProjectStatus(OpportunityStatusEnum.Unassigned)}
        checked={isChecked(filters.status, "UNASSIGNED")}
        onCheckFilter={actions.setStatus}
      />

      <FilterCheckbox
        id="ASSIGNED"
        value="ASSIGNED"
        label={translateProjectStatus(OpportunityStatusEnum.Assigned)}
        checked={isChecked(filters.status, "ASSIGNED")}
        onCheckFilter={actions.setStatus}
      />
      <FilterCheckbox
        id="IN_PROGRESS"
        value="IN_PROGRESS"
        label={translateProjectStatus(OpportunityStatusEnum.InProgress)}
        checked={isChecked(filters.status, "IN_PROGRESS")}
        onCheckFilter={actions.setStatus}
      />
      <FilterCheckbox
        id="CLOSED_WON"
        value="CLOSED_WON"
        label={translateProjectStatus(OpportunityStatusEnum.ClosedWon)}
        checked={isChecked(filters.status, "CLOSED_WON")}
        onCheckFilter={actions.setStatus}
      />
      <FilterCheckbox
        id="CLOSED_LOST"
        value="CLOSED_LOST"
        label={translateProjectStatus(OpportunityStatusEnum.ClosedLost)}
        checked={isChecked(filters.status, "CLOSED_LOST")}
        onCheckFilter={actions.setStatus}
      />
      <FilterCheckbox
        id="INVALID"
        value="INVALID"
        label={translateProjectStatus(OpportunityStatusEnum.Invalid)}
        checked={isChecked(filters.status, "INVALID")}
        onCheckFilter={actions.setStatus}
      />

      <FilterCheckbox
        id="NO_ACTION_PLANNED"
        value="NO_ACTION_PLANNED"
        label={t("status.no_action_planned")}
        checked={filters.isNoActionPlanned}
        onCheckFilter={(_, checked) => {
          actions.setIsNoActionPlanned(checked);
        }}
      />
      {isColdProjectEnabled && (
        <FilterCheckbox
          id="IS_COLD_PROJECT"
          value="IS_COLD_PROJECT"
          label={t("status.cold_project")}
          checked={filters.isColdProject}
          onCheckFilter={(_, checked) => {
            actions.setIsColdProject(checked);
          }}
        />
      )}
    </FilterListContainer>
  );
};
